export default function Container({ children, className = "" }) {
  return (
    <div className={`mx-auto px-6 ${className}`} style={{ maxWidth: "1280px" }}>
      {children}
    </div>
  );
}